import type { Component, ComponentProps } from "solid-js";
import type { PricingPageParams } from "~/solidJs/shared/models/pageParams";

export interface PricingPageState {
	subscriptionType: PricingPageParams.SubscriptionType;
	subscriptionLength: PricingPageParams.SubscriptionLength;
	paymentCurrency: PricingPageParams.PaymentCurrency;
	promo: string;
}

export interface FeedBackListItem {
	name: string;
	position: string;
	feedBack: string;
	userPick: string;
	Icon: Component<ComponentProps<"svg">>;
}

export interface QaItem {
	id: string;
	question: string;
	answer: string;
}

export interface QaGroup {
	heading: string;
	questions: QaItem[];
}

export interface GroupedQa {
	items: QaGroup[];
}

export interface ProductsSectionPropsV3 {
	forceSelectedPlan?: string;
	trialSelectedPlan?: string;
	sourceGlobalId?: string;
}

export interface EnterpriseFeature {
	text: string;
}

export const SAMPLE_QAS: GroupedQa = {
	items: [
		{
			heading: "Credits",
			questions: [
				{
					id: "how-credits-work",
					question: "How do credits work?",
					answer: "Credits are used to generate content. Each AI generation consumes a certain number of credits depending on the complexity and length of the output."
				},
				{
					id: "credits-rollover",
					question: "Do unused credits roll over to the next month?",
					answer: "Unused credits typically do not roll over to the next month unless specified in your subscription plan. Please check your plan details for more information."
				},
				{
					id: "buy-more-credits",
					question: "Can I buy more credits if I run out?",
					answer: "Yes, you can purchase additional credits if you run out before your next billing cycle. Options to buy more credits are available in your account settings."
				}
			]
		},
		{
			heading: "Models",
			questions: [
				{
					id: "all-models-available",
					question: "Are all AI models available on all plans?",
					answer: "The availability of AI models varies by subscription plan. Premium plans generally offer access to a wider range of advanced AI models. Please refer to our features table for a detailed comparison."
				}
			]
		},
		{
			heading: "Team",
			questions: [
				{
					id: "plan-for-teams",
					question: "Is there a plan for teams or agencies?",
					answer: "Yes, we offer dedicated plans for teams and agencies with features tailored for collaborative work, higher usage limits, and centralized billing. Please explore our Enterprise plans for more details."
				}
			]
		}
	]
};

export const ENTERPRISE_FEATURES: string[] = [
	"Unlimited seats",
	"SLA & legal contract (with invoice payments)",
	"Dedicated manager",
	"API & integration support",
	"Custom model deployment",
	"Advanced analytics & usage reports",
	"Fine-tuned governance & compliance",
	"SSO & custom authentication",
	"Onboarding & training sessions"
];

export const FEEDBACK_DATA: FeedBackListItem[] = [
	{
		name: "Ivan Tikhomirov",
		position: "Design Director",
		feedBack:
			"The most accessible and easy-to-use Al tool for artists. You don't need to figure out colabs or difficult payments. You get the most popular useful neural networks in one place.",
		userPick: "/dev/null/user_pick_placeholder.jpg",
		Icon: {} as Component<ComponentProps<"svg">> // Будет заменено в ui
	},
	{
		name: "Anna Poliakova",
		position: "Design Lead",
		feedBack:
			"I've tried many web tools, and so far Phygital+ is the best one. It's very convenient to use \"out of the box.\" It's a perfect product for those who want a flexible solution that doesn't require much learning time.",
		userPick: "/dev/null/user_pick_placeholder.jpg",
		Icon: {} as Component<ComponentProps<"svg">> // Будет заменено в ui
	},
	{
		name: "Anna Poliakova",
		position: "Design Director",
		feedBack:
			"Phygital+ AI Tool is an incredible tool that will save you a lot of time. With it, you can invest your time not in the endless AI models setup, but in art and creativity.",
		userPick: "/dev/null/user_pick_placeholder.jpg",
		Icon: {} as Component<ComponentProps<"svg">> // Будет заменено в ui
	}
];
